import api from '@services/api';
import { PaginationResponse } from '@/app/models/pagination';
import { Cluster } from '../models/cluster';

/**
 * <p>
 * API endpoints that cover all resource sharing CRUD calls
 */

type QueryParams = {
  searchTerm?: string;
  page: number;
  size: number;
  sortKey?: string;
  sortDirection?: string;
};

export const clusterApi = api.injectEndpoints({
  endpoints: (builder) => ({
    cluster: builder.query<PaginationResponse<Cluster>, QueryParams>({
      query: (queryInput) => ({
        url: encodeURI(
          `/salary/cluster/search?searchTer=${queryInput.searchTerm}&page=${queryInput.page}&size=${queryInput.size}&${
            queryInput.searchTerm ? `searchTerm=${queryInput.searchTerm}&` : ''
          }${queryInput.sortKey ? `&sortKey=${queryInput.sortKey}` : ''}${
            queryInput.sortDirection ? `&sortDirection=${queryInput.sortDirection}` : ''
          }`,
        ),
      }),
      providesTags: ['Cluster'],
    }),
  }),
});

export const { useClusterQuery } = clusterApi;
